/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');

      // Call onResize directly to set initial state based on window size
      this.onResize();

      // Add resize event listener
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      // Remove resize event listener when element is removed
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      this.accordions.forEach((accordion) => {
        if (window.innerWidth > 768) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}
document.addEventListener('DOMContentLoaded', function () {

  function initAscensionSlideshow() {
    const sliders = document.querySelectorAll('.swiper');

    sliders.forEach(slider => {
      if (!slider.swiper) return;

      const swiper = slider.swiper;

      // IMAGE SLIDES → 40 seconds
      swiper.params.autoplay = {
        delay: 40000,
        disableOnInteraction: false
      };
      swiper.autoplay.start();

      // VIDEO SLIDES → move on video end
      const videos = slider.querySelectorAll('video');

      videos.forEach(video => {
        video.addEventListener('ended', () => {
          swiper.slideNext();
        });

        // ensure autoplay
        video.play().catch(() => {});
      });
    });
  }

  // delay required because Ascension loads swiper late
  setTimeout(initAscensionSlideshow, 1500);

});
